module.exports = __webpack_public_path__ + "img/IndustrialDigitization.9bb5e780.svg";